import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShoeInsolesComponent } from './shoe-insoles.component';

const routes: Routes = [
    {
      path: '',
      data: {
        title: 'Shoe Insoles'
      },
      children: [
        {
          path: '',
          component: ShoeInsolesComponent,
          data: {
            title: 'Home'
          }
        }
      ]
    }
  ];

  @NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class ShoeInsolesRoutingModule { }
